// =============================================================================
// Workspace Service
// =============================================================================

import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../config/api.js';

class WorkspaceService {
  constructor() {
    this.baseURL = '/api/workspaces';
  }

  // Get all workspaces for current user
  async getWorkspaces() {
    try {
      const response = await apiClient.get(this.baseURL);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get workspaces');
    }
  }

  // Get workspace statistics (all workspaces)
  async getWorkspaceStats() {
    try {
      const response = await apiClient.get(`${this.baseURL}/stats`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get workspace stats');
    }
  }

  // Get single workspace statistics
  async getWorkspaceStatsById(workspaceId) {
    try {
      const response = await apiClient.get(`/plugin/workspaces/${workspaceId}/stats`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get workspace stats');
    }
  }

  // Get available templates
  async getTemplates() {
    try {
      const response = await apiClient.get(`${this.baseURL}/templates`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get templates');
    }
  }

  // Create new workspace
  async createWorkspace(workspaceData) {
    try {
      const response = await apiClient.post(this.baseURL, workspaceData);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to create workspace');
    }
  }

  // Get workspace by ID
  async getWorkspace(id) {
    try {
      const response = await apiClient.get(`${this.baseURL}/${id}`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get workspace');
    }
  }

  // Update workspace
  async updateWorkspace(id, updates) {
    try {
      const response = await apiClient.put(`${this.baseURL}/${id}`, updates);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to update workspace');
    }
  }

  // Delete workspace
  async deleteWorkspace(id) {
    try {
      await apiClient.delete(`${this.baseURL}/${id}`);
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to delete workspace');
    }
  }

  // Start workspace
  async startWorkspace(id) {
    try {
      const response = await apiClient.post(`${this.baseURL}/${id}/start`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to start workspace');
    }
  }

  // Stop workspace
  async stopWorkspace(id) {
    try {
      const response = await apiClient.post(`${this.baseURL}/${id}/stop`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to stop workspace');
    }
  }
}

// Create and export singleton instance
export const workspaceService = new WorkspaceService();
